export enum GeoColumns {
  CLIENT = "Client",
  COMPANY = "Company",
  REGION = "Region",
  GROUP = "Group",
  LOCATION = "Location",
}
